import { GrupoModel, GRUPO_DEFAULT } from "./GrupoModel";

export interface CadastroUsuarioModel {
  id?: number;
  nome: string;
  nomeUsuario: string;
  grupo: GrupoModel;
}

export const USUARIO_DEFAULT = () => {
  return {
    nome: "",
    nomeUsuario: "",
    grupo: GRUPO_DEFAULT(),
  };
};
